export default __webpack_public_path__ + "static/loupe-navigation-redesign-user-context-ae28a29015727665d7be552af0a149b0.png";